export function generateMonthsOfYear(date: Date): Date[] {
  const dates: Date[] = [];
  for (let i = 0; i < 12; i++) {
    dates.push(new Date(date.getFullYear(), i, 1));
  }
  return dates;
}
